import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SessionService } from '@services/session.service';

export const isNotLoggedInGuard: CanActivateFn = () => {
  return !inject(SessionService).authToken
    ? true
    : inject(Router).createUrlTree(['/']);
};
